import React from "react";
import TabContent from "./TabContent";

const RolesSection = (props) => {

    const roleClick = (event, key) => {
        if(props.roleClick)
            props.roleClick(event, key, props.name);
    }

    var roleList = props.roleList.map((role) => {
        return (
            <div key={role.key} className={["role",role.active ? 'active' : ''].join(' ')} onClick={(event) => roleClick(event, role.key)}>{role.title ?? props.defaultRoleList }</div>
        )
    })

    return (
        <section className="roles-section">
            <div className="roles-list">
                {roleList}
            </div>
        </section>
    )
};

export default RolesSection;